import { css } from '@inter-ikea-kompis/web-component';
import type { ITheme } from '@inter-ikea-kompis/types';

type Options = {
	theme: ITheme;
};

export default class IconPillGroupStyle {
	public static getStyle(options: Options): string {
		const { spacing } = options.theme;
		return css`
			.container {
				flex-wrap: wrap;
				display: inline-flex;
			}
			::slotted(kompis-icon-pill) {
				margin: ${spacing.space25 / 16}rem;
			}
			kompis-icon-pill {
				margin: ${spacing.space25 / 16}rem;
			}
		`;
	}
}
